import React from "react";
import { withRouter } from "react-router-dom";
import "./Screen.scss";
import { compose } from "react-apollo";
import { withStore } from "../../store";
import Fetch from "../../components/Fetch/Fetch";
import Loading from "../../components/Loading/Loading";
import ErrorOverlay from "../../components/ErrorOverlay/ErrorOverlay";
import AppDownloads from "../../components/AppDownloads/AppDownloads";
import CategorizedSearch from "../../components/CategorizedSearch/CategorizedSearch";
import Helmet from "react-helmet";
import { getClientApiURL } from "../../utils"
import ScreenParser from "../../parser/ScreenParser";
import ServiceMessages from "../../components/ServiceMessages/ServiceMessages";

const Screen: React.FunctionComponent<any> = ({ store: { language }, match }) => {
  const screenUuid = match && match.params && match.params.uuid;
  const screenPath = screenUuid ? `/screen/${screenUuid}?hero=true` : process.env.REACT_APP_HOMEPAGE_URL;
  const fetchUrl = getClientApiURL(screenPath);

  return (
    <Fetch
      key={screenPath}
      url={fetchUrl}
      addMiddlewareHeaders
      options={{ credentials: "include" }}
      authzBeforeRequest
      >
      {(loading, errors, data) => {
        let screen = ScreenParser((data && data.screen) || {}, language);
        let serviceMessages = (data && data.serviceMessages) || [];

        return (
          errors ?
          <ErrorOverlay /> :
          <div className="Screen">
            { loading && <Loading /> }
            <Helmet>
              <title>{screen.title}</title>
            </Helmet>
            { serviceMessages && <ServiceMessages messages={serviceMessages} /> }
            { data &&
              <React.Fragment>
                  {
                  screen.components.map((component, index) => {
                    if (component.props.componentType === "SCREEN_HERO") {
                      return component;
                    }
                    return false;
                  })
                }
                <div className="content">
                   {
                    screen.components.map((component, index) => {
                      if (component.props.componentType !== "SCREEN_HERO") {
                        return component;
                      }
                      return false;
                    })
                }
                  
                </div>
              </React.Fragment>
            }
          </div>
        )
      }}
    </Fetch>
  )
};

export default compose(withRouter, withStore)(Screen);
